/**
 * @generated SignedSource<<add31341547a98da07aadd54d81fbfbd>>
 * @relayHash 69c788fb9130c8d7b49c7c38b82f5bc2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 77cdd34c8df9927e434e29634186bf87fd654688299078e1464c3cca06637c31

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EditorTitleWithTitleAreaComponentsQuery$variables = {
  includeStudioAutomationDiscovery: boolean;
  siteAri: string;
};
export type EditorTitleWithTitleAreaComponentsQuery$data = {
  readonly meetingNotesAutomationDiscovery?: {
    readonly " $fragmentSpreads": FragmentRefs<"MeetingNotesAutomationDiscovery_query">;
  } | null;
};
export type EditorTitleWithTitleAreaComponentsQuery = {
  response: EditorTitleWithTitleAreaComponentsQuery$data;
  variables: EditorTitleWithTitleAreaComponentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeStudioAutomationDiscovery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteAri"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EditorTitleWithTitleAreaComponentsQuery",
    "selections": [
      {
        "condition": "includeStudioAutomationDiscovery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "siteAri",
                      "variableName": "siteAri"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "MeetingNotesAutomationDiscovery_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "meetingNotesAutomationDiscovery"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditorTitleWithTitleAreaComponentsQuery",
    "selections": [
      {
        "condition": "includeStudioAutomationDiscovery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "siteAri"
              }
            ],
            "concreteType": "AdminUnitLinkedResource",
            "kind": "LinkedField",
            "name": "admin_unitLinkedResource",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "AdminUnitLinkedConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AdminUnitLinkedEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AdminUnitLinkedTo",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "69c788fb9130c8d7b49c7c38b82f5bc2",
    "id": "77cdd34c8df9927e434e29634186bf87fd654688299078e1464c3cca06637c31",
    "metadata": {},
    "name": "EditorTitleWithTitleAreaComponentsQuery",
    "operationKind": "query",
    "text": "query EditorTitleWithTitleAreaComponentsQuery($siteAri:ID!,$includeStudioAutomationDiscovery:Boolean!){...MeetingNotesAutomationDiscovery_query_1JkdhI@include(if:$includeStudioAutomationDiscovery)}fragment MeetingNotesAutomationDiscovery_query_1JkdhI on Query{admin_unitLinkedResource(id:$siteAri){id,links{edges{node{id}}}}}"
  }
};
})();

(node as any).hash = "7cefacedc53ad4ccf97de2234e87fd73";

export default node;
